import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CloseFabButtonComponent',
  emits: ["OnClose"],
  setup(__props, { emit: __emit }) {

const IsMobile = inject("IsMobile");
const emit = __emit;
function onCLoseMe() {
    emit("OnClose");
}

return (_ctx: any,_cache: any) => {
  const _component_VarIcon = _resolveComponent("VarIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['close-fab-button-body',_unref(IsMobile)? '': 'pc-close-fab-button-body'])
  }, [
    _createVNode(_component_VarIcon, {
      size: "50",
      name: "close-circle",
      class: "close-fab-button",
      onClick: onCLoseMe
    })
  ], 2))
}
}

})